<template>
  <el-select
    v-model="state.value"
    :placeholder="props.placeholder"
    :style="{ width: props.width + 'px' }"
  >
    <el-option
      v-for="item in state.arr_data"
      :key="item"
      :label="item.Text"
      :value="item.Key"
      :style="{
        color: props.color ? item.Color : '',
      }"
    />
  </el-select>
</template>

<script>
import { onMounted, reactive } from "vue";
import constant from "@/utils/constant";
export default {
  props: {
    arrName: String, //状态数组名称
    value: Object, //值
    //是否显示颜色
    color: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "--请选择--",
    },
    width: {
      type: Number,
      default: 200,
    },
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      state.value = props.value;
      state.arr_data = constant[props.arrName];
    });

    const onChange = (e) => {
      emit("update:modelValue", e);
    };
    return { state, props, onChange };
  },
};
</script>
<style scoped></style>
